import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Box, Icon, Typography } from '@material-ui/core';

import useStyles from './styles';

const RatingChart = ({ rate, size, onChange, showLegend }) => {
  const classes = useStyles();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [rating, setRating] = useState(rate);
  const [legend, setLegend] = useState(rate);
  const [filledItems, setFilledItems] = useState(rate);
  const [interactive, setInteractive] = useState(false);

  const rateLegends = useMemo(
    () => ['Muito ruim', 'Ruim', 'Regular', 'Bom', 'Muito bom'],
    [],
  );

  const rateItems = useMemo(
    () =>
      Array.from({ length: 5 }, (v, index) => ({
        value: index + 1,
      })),
    [],
  );

  useEffect(() => {
    setInteractive(!!onChange);
  }, [onChange]);

  useEffect(() => {
    setLegend(rating);
    setFilledItems(rating);
  }, [rating]);

  const handleClickRate = useCallback(
    value => {
      if (interactive) {
        setRating(value);
        onChange(value);
      }
    },
    [interactive, onChange],
  );

  const handleHoverItem = useCallback(
    value => {
      setHoveredItem(value || null);
      if (interactive) {
        setLegend(value || rating);
        setFilledItems(value || rating);
      }
    },
    [rating, interactive],
  );

  return (
    <Box className={`${classes.container} ${size}`}>
      <Box className="rating-list-container">
        {rateItems.map(({ value }) => (
          <Icon
            key={value}
            className={`rating-list-item ${
              value <= filledItems ? 'filled' : 'empty'
            } ${value < hoveredItem && 'hovered'}`}
            fontSize="inherit"
            onClick={() => handleClickRate(value)}
            onMouseEnter={() => handleHoverItem(value)}
            onMouseLeave={() => handleHoverItem(null)}
          >
            star
          </Icon>
        ))}
      </Box>
      {showLegend && (
        <Typography className="rating-legend" variant="caption">
          {rateLegends[legend - 1]}
        </Typography>
      )}
    </Box>
  );
};

export default RatingChart;
